import React from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import '../css/SignIn.css';

function SignIn({ onSignIn }) {
  const googleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        // Get token info
        const verificationResponse = await fetch(
          `https://oauth2.googleapis.com/tokeninfo?access_token=${tokenResponse.access_token}`
        );
        const verificationData = await verificationResponse.json();

        // Get user profile
        const userInfoResponse = await fetch(
          'https://www.googleapis.com/oauth2/v3/userinfo',
          {
            headers: {
              Authorization: `Bearer ${tokenResponse.access_token}`,
            },
          }
        );
        const userProfile = await userInfoResponse.json();

        if (verificationData.email_verified === "true") {
          console.log("User is verified, allowing access to bot.");
          // Pass both access token and user profile to parent
          onSignIn({
            access_token: tokenResponse.access_token,
            profile: userProfile
          });
        } else {
          console.error("Email is not verified, access denied.");
          onSignIn(false);
        }
      } catch (error) {
        console.error("Error during token verification:", error);
        onSignIn(false);
      }
    },
    onError: (error) => {
      console.error('Google login failed', error);
      onSignIn(false);
    },
    ux_mode: 'popup',
    scope: 'email profile'
  });

  return (
    <div className="signin-overlay">
      <div className="signin-container">
        <div className="signin-header">
          <h1>KPOINT Prism</h1>
          <p>Sign in to access the Prism</p>
        </div>
        <div className="signin-form">
          {/* <button className="signin-btn" >
            Log in with Google
          </button> */}
          <button className="signup-btn" onClick={() => googleLogin()}>Sign in with Google</button>
        </div>
        {/* <div className="stay-logged-out">
          <a href="#">Stay logged out</a>
        </div> */}
      </div>
    </div>
  );
}

export default SignIn;